import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './Routes';
import reportWebVitals from './reportWebVitals';
import SessionAuthProvider from './Context/session-auth-context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <SessionAuthProvider>
      <App />
    </SessionAuthProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
